import { useState, useEffect } from 'react';

const RESULTS_URL = 'https://resultados.novaimagemdiagnostico.com.br/portal/paciente_nova.html';

export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    } else {
      // Se não estiver na home, redireciona para a home com o hash
      window.location.href = `/#${id}`;
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('inicio')}>
            <img
              src="https://static.readdy.ai/image/060e1c25caffef29cb7917b5a22faf7c/16acb801c9742b924ec5abef0621b19e.png"
              alt="Nova Imagem - Diagnóstico por Imagem"
              className="h-16 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center space-x-6">
            <button onClick={() => scrollToSection('inicio')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium cursor-pointer whitespace-nowrap">
              Início
            </button>
            <button onClick={() => scrollToSection('sobre')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium cursor-pointer whitespace-nowrap">
              Sobre a Clínica
            </button>
            <button onClick={() => scrollToSection('exames')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium cursor-pointer whitespace-nowrap">
              Exames
            </button>
            <button onClick={() => scrollToSection('convenios')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium cursor-pointer whitespace-nowrap">
              Convênios
            </button>
            <button onClick={() => scrollToSection('agendamento')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium cursor-pointer whitespace-nowrap">
              Agendamentos e Contato
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-blue-600 cursor-pointer"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-xl overflow-y-auto max-h-[calc(100vh-80px)]">
          <div className="px-6 py-8 space-y-2">
            <button onClick={() => scrollToSection('inicio')} className="block w-full text-left text-gray-700 hover:text-blue-600 transition-colors font-semibold py-4 border-b border-gray-50 cursor-pointer text-lg">
              Início
            </button>
            <button onClick={() => scrollToSection('sobre')} className="block w-full text-left text-gray-700 hover:text-blue-600 transition-colors font-semibold py-4 border-b border-gray-50 cursor-pointer text-lg">
              Sobre a Clínica
            </button>
            <button onClick={() => scrollToSection('exames')} className="block w-full text-left text-gray-700 hover:text-blue-600 transition-colors font-semibold py-4 border-b border-gray-50 cursor-pointer text-lg">
              Exames
            </button>
            <button onClick={() => scrollToSection('convenios')} className="block w-full text-left text-gray-700 hover:text-blue-600 transition-colors font-semibold py-4 border-b border-gray-50 cursor-pointer text-lg">
              Convênios
            </button>
            <button onClick={() => scrollToSection('agendamento')} className="block w-full text-left text-gray-700 hover:text-blue-600 transition-colors font-semibold py-4 border-b border-gray-50 cursor-pointer text-lg">
              Agendamentos e Contato
            </button>
            <div className="pt-6 space-y-4">
              <button
                onClick={() => {
                  window.open(RESULTS_URL, '_blank', 'noopener,noreferrer');
                  setIsMobileMenuOpen(false);
                }}
                className="block w-full text-center bg-white border-2 border-blue-600 text-blue-600 px-6 py-4 rounded-xl hover:bg-blue-50 transition-all font-bold cursor-pointer text-lg shadow-sm"
              >
                Resultados de Exames
              </button>
              <button onClick={() => scrollToSection('agendamento')} className="w-full bg-blue-600 text-white px-6 py-4 rounded-xl hover:bg-blue-700 transition-all font-bold shadow-lg cursor-pointer whitespace-nowrap text-lg">
                Agendar Exames
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
